import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import fakeModalData from './fakeModalData';
import Screens from '../../screens';

var CheatMenu = /*#__PURE__*/function (_Component) {
  _inherits(CheatMenu, _Component);

  var _super = _createSuper(CheatMenu);

  function CheatMenu() {
    var _this;

    _classCallCheck(this, CheatMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      modal: '',
      gameId: 0
    };

    _this.handleModalChange = function (modal) {
      _this.setState({
        modal: modal
      });
    };

    _this.handleGoToModalClick = function () {
      var _objectSpread2;

      var modal = _this.state.modal;
      if (modal === '') return;
      var fakeData = fakeModalData[modal] || {};
      var fakeParams = fakeData.params || {};
      var fakeDataSetup = fakeData.setup;
      if (fakeDataSetup) fakeDataSetup();
      QueryParamsProxy.setQueryParams(_objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, RouteParamConstants.PARAM_MODAL, modal), _defineProperty(_objectSpread2, RouteParamConstants.PARAM_CHEAT_MENU_ACTIVE, true), _objectSpread2), fakeParams));
    };

    _this.handleTestGame = function () {
      var _QueryParamsProxy$nav;

      QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
      QueryParamsProxy.navigate(_this.props.navigation, Screens.Game, (_QueryParamsProxy$nav = {}, _defineProperty(_QueryParamsProxy$nav, RouteParamConstants.PARAM_GAME_ID, _this.state.gameId), _defineProperty(_QueryParamsProxy$nav, RouteParamConstants.PARAM_CHEAT_MENU, 'yes'), _QueryParamsProxy$nav));
    };

    _this.handleGameIdChange = function (gameId) {
      _this.setState({
        gameId: gameId
      });
    };

    return _this;
  }

  _createClass(CheatMenu, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          modal = _this$state.modal,
          gameId = _this$state.gameId;
      return this.props.render({
        modal: modal,
        gameId: gameId,
        handleModalChange: this.handleModalChange,
        handleGoToModalClick: this.handleGoToModalClick,
        handleGameIdChange: this.handleGameIdChange,
        handleTestGame: this.handleTestGame
      });
    }
  }]);

  return CheatMenu;
}(Component);

export { CheatMenu as default };